import { LoaderFunction } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import {BookmarkGroupData} from "@/routes/bookmarks/types/bookmarkGroupData.ts";

export const bookmarksLoader: LoaderFunction = async (): Promise<BookmarkGroupData[]> => {
    try {

        let loaderData = [] as BookmarkGroupData[];
        const apiResponse = await apiEndpoints.getAllBookmarkGroups();
        if (apiResponse.success)
            loaderData = apiResponse.data;
        return loaderData;
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : "Unknown error");
    }
};
